export default __webpack_public_path__ + "img/48d0c12e654e1fa940cc659c621aa0bb.png";